import { Pagination, UpdaterProfile } from '@ekkogmbh/apisdk';
import { ListItemText } from '@mui/material';
import React, { useCallback } from 'react';
import PaginatedSelect from 'src/Common/Components/Forms/PaginatedSelect';
import useEkko from 'src/Common/Providers/EkkoProvider';

interface Props {
  coordinate: string;
  selected?: Required<Pick<UpdaterProfile, 'name' | 'coordinate'>> &
    Partial<Omit<UpdaterProfile, 'name' | 'coordinate'>>;
  optional?: boolean;
  onChange: (profile: UpdaterProfile | undefined) => void;
  disabled?: boolean;
  label?: string;
}

export const UpdaterProfilePicker = ({ label, coordinate, selected, onChange, ...props }: Props): React.JSX.Element => {
  const { api } = useEkko();

  const fetchItems = useCallback(
    (pagination: Pagination) =>
      api.getUpdaterProfiles({
        ...pagination,
        filter: { coordinate },
      }),
    [api, coordinate],
  );

  return (
    <PaginatedSelect
      {...props}
      label={label ?? 'Updater Profile'}
      value={selected as UpdaterProfile | undefined}
      itemId={(up) => up.coordinate + '::' + up.name}
      itemRender={(up) => <ListItemText primary={up.name} secondary={up.coordinate} />}
      fetchPaginatedItems={fetchItems}
      onChange={(up) => onChange(up as UpdaterProfile | undefined)}
    />
  );
};
